import { EntityModel } from '@/interfaces'
import {
  ALL_BOOKING_ADDONS_QUERY,
  CREATE_BOOKING_ADDON_MUTATION,
  DELETE_BOOKING_ADDON_MUTATION,
  FORCE_DELETE_BOOKING_ADDON_MUTATION,
  SINGLE_BOOKING_ADDON_QUERY,
  UPDATE_BOOKING_ADDON_MUTATION,
} from './graphql'
import travelPricingServiceCalculationSettingsEntity from '@/entities/travelPricingServiceCalculationSettings/entity'
import travelPricingMandatorySettingsEntity from '@/entities/travelPricingMandatorySettings/entity'

const ratioBookingAddonModel: EntityModel = {
  name: 'bookingAddon',
  namePlural: 'bookingAddons',
  uniqueName: 'ratioBookingAddon',
  uniqueNamePlural: 'ratioBookingAddons',
  path: 'travel/pricing/adaptors/ratio/booking_addon',
  baseUrl: '/travel/pricing/adaptors/ratio/booking_addons',
  translationPrefix: 'entities:ratioBookingAddon.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_BOOKING_ADDONS_QUERY,
    getSingle: SINGLE_BOOKING_ADDON_QUERY,
    create: CREATE_BOOKING_ADDON_MUTATION,
    update: UPDATE_BOOKING_ADDON_MUTATION,
    delete: DELETE_BOOKING_ADDON_MUTATION,
    forceDelete: FORCE_DELETE_BOOKING_ADDON_MUTATION,
  },
  attributes: {
    ratioServiceNo: {
      name: 'ratioServiceNo',
      label: 'entities:ratioBookingAddon.attributes.ratioServiceNo.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    name: {
      name: 'name',
      label: 'entities:ratioBookingAddon.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:ratioBookingAddon.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:ratioBookingAddon.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      maxLength: 255,
      validationType: 'string',
      validations: [],
    },
    calculationSettings: {
      name: 'calculationSettings',
      label: 'entities:ratioBookingAddon.attributes.calculationSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingServiceCalculationSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    mandatorySettings: {
      name: 'mandatorySettings',
      label: 'entities:ratioBookingAddon.attributes.mandatorySettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingMandatorySettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioBookingAddonModel
